import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { View, FlatList, useWindowDimensions } from 'react-native';
import { Card } from 'react-native-paper';
import CustomLabel from '../../../components/CustomLabel/CustomLabel';
import { SafeAreaView } from 'react-native-safe-area-context';
import CustomButton from '../../../components/CustomButton';
import { useHRAdminEmployees } from '../../../hooks/useHRAdminEmployees';
import Ionicons from "@react-native-vector-icons/ionicons/static";
import CustomControlledInput from '../../../components/ControlledComponents/CustomControlledInput';
import CustomControlledDropdown from '../../../components/ControlledComponents/CustomControlledDropdown';
import { useTableHelper } from '../../../hooks/useTableHelper';

const FlatListView = React.memo(({ item, styles, t, control, handleDelete,
    modal, setValue, index, options
}) => {
    return (
        <SafeAreaView>
            <SafeAreaView>
                <SafeAreaView>
                    <SafeAreaView style={styles.row}>
                        <View
                            style={[styles.item]}>
                            <SafeAreaView>
                                <CustomLabel value={t(`common:day`)} type='SUBTITLENOFLEX' />
                                <CustomControlledDropdown
                                    multipleSelect={true}
                                    control={control}
                                    name={`${item.schedUI}.day`}
                                    type="TIMESHEET"
                                    options={options}
                                    setValue={setValue}
                                />
                            </SafeAreaView>
                        </View>
                        <View
                            style={[styles.item]}>
                            <SafeAreaView>
                                <CustomLabel value={t(`common:from`)} type='SUBTITLENOFLEX' />
                                <CustomControlledInput
                                    name={`${item.schedUI}.fromHr`}
                                    control={control}
                                    editable={true}
                                    type='EDIT_EMPLOYEE'
                                />
                            </SafeAreaView>
                        </View>
                        <View
                            style={[styles.item]}>
                            <SafeAreaView>
                                <CustomLabel value={t(`common:to`)} type='SUBTITLENOFLEX' />
                                <CustomControlledInput
                                    name={`${item.schedUI}.toHr`}
                                    control={control}
                                    editable={true}
                                    type='EDIT_EMPLOYEE'
                                />
                            </SafeAreaView>
                        </View>
                        <View
                            style={[styles.item]}>
                            <SafeAreaView>
                                <CustomLabel value={t(`common:Comm`)} type='SUBTITLENOFLEX' />
                                <CustomControlledInput
                                    name={`${item.schedUI}.description`}
                                    control={control}
                                    editable={true}
                                    type='EDIT_EMPLOYEE'
                                />
                            </SafeAreaView>
                        </View>
                        <View style={styles.verticalLine} />
                        <SafeAreaView>
                            <CustomButton
                                iconName={"trash-outline"}
                                onPress={() => {
                                    handleDelete(item, index, 'schedUI', modal)
                                }}
                                show='PART'
                                type='PART'
                                textTop='0'
                                sz={30} />
                        </SafeAreaView>
                    </SafeAreaView>
                </SafeAreaView>
            </SafeAreaView>
        </SafeAreaView>
    )
})


const HRAdminSchedule = ({ props }) => {

    //#region Variables
    const { selectedEmployee, flatlistEditPress, styles,
        modal, t, modalVisible, setModalVisible, ActivityIndicator, colors
    } = props;
    const { height } = useWindowDimensions();
    const [changes, setChanges] = useState([]);
    const { getSchedule, insertSchedule, updateSchedule, deleteSchedule } = useHRAdminEmployees();
    const [schedule, setSchedule] = useState([]);
    const [insertData, setInsertData] = useState([]);
    const [deletedItems, setDeletedItems] = useState([]);
    const [originalData, setOriginalData] = useState([]);
    const [duplicates, setDuplicates] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const { handleCancelChanges, rowAdd, rowDelete, rowEdit } = useTableHelper();
    const { control, handleSubmit, formState: { errors }, setValue, unregister } = useForm();
    const options = [
        { value: "0-MON", label: "Monday" },
        { value: "1-TUE", label: "Tuesday" },
        { value: "2-WED", label: "Wednesday" },
        { value: "3-THU", label: "Thursday" },
        { value: "4-FRI", label: "Friday" },
        { value: "5-SAT", label: "Saturday" },
        { value: "6-SUN", label: "Sunday" }
    ];
    const [state, setState] = useState(null);
    const [showState, setShowState] = useState(false);
    const ref = useRef(null);
    //#endregion

    //#region UseEffect
    useEffect(() => {
        setIsLoading(true);
        getSchedule(selectedEmployee?.employeeID).then((res) => {
            let schedule = res?.data;
            setSchedule(schedule);
            setOriginalData(schedule);
            schedule.forEach((item, index) => {
                Object.keys(item).forEach(key => {
                    setValue(`${item.schedUI}.${key}`, item[key]);
                });
            });
            setIsLoading(false);
        })
    }, []);

    useEffect(() => {
        if (state) {
            setShowState(true);
            const timer = setTimeout(() => {
                setShowState(false);
            }, 10000);
            return () => clearTimeout(timer);
        }
    }, [state]);
    //#endregion

    //#region Submit
    const onSubmit = data => {
        let remainingObjects = [];
        let employeeid = selectedEmployee?.employeeID;
        Object.keys(data).forEach((key, index) => {
            if (!insertData.includes(key) && !deletedItems.includes(key)) {
                remainingObjects.push(data[key]);
            }
        });
        insertData.forEach((schedUI, indexInsert) => {
            deletedItems.forEach((delUi, indexDelete) => {
                if (schedUI === delUi) {
                    insertData.splice(indexInsert, 1);
                    deletedItems.splice(indexDelete, 1);
                }
            });
        });
        const insertObjects = findObjects(data, insertData, employeeid);
        submitData(insertObjects, remainingObjects, deletedItems)
    };

    const submitData = async (insertData, updateData, deleteData, employeeid) => {
        let newPromises = [];
        let deleteSucc = true;
        let updateSucc = true;
        let insertSucc = true;

        setIsLoading(true);
        setState('saving');
        if (insertData.length > 0)
            newPromises.push(
                insertSchedule(insertData, employeeid).then((res) => {
                    if (res?.status === 200) insertSucc = true;
                }).catch(() => { })
            )
        if (deleteData.length > 0)
            newPromises.push(
                deleteSchedule(deleteData, employeeid).then((res) => {
                    if (res?.status === 200) deleteSucc = true;
                }).catch(() => { })
            )
        if (updateData.length > 0)
            newPromises.push(
                updateSchedule(updateData, employeeid).then((res) => {
                    if (res?.status === 200)
                        updateSucc = true;
                }).catch(() => { })
            )
        try {
            await Promise.all(newPromises).then(() => {
                if (!updateSucc) {
                    if (!deleteSucc) {
                        setState('deleteFailed');
                    }
                    else
                        setState('issueMessage');
                }
                else if (deleteSucc && updateSucc && insertSucc) {
                    setState('allOperationsSuccMess');
                }
                setIsLoading(false);
            });
        } catch (error) {
            console.log(error)
        }
    }
    //#endregion

    //#region Helpers
    const findObjects = (mainObject, arr, employeeid) => {
        return arr.map(schedUI => {
            const innerObject = mainObject[schedUI];
            if (innerObject) {
                return { ...innerObject, schedUI, employeeid };
            }
            return null;
        }).filter(item => item !== null);
    };
    //#endregion

    //#region Handlers
    const handleAddPress = () => {
        let exceptions = [];
        rowAdd(schedule, setSchedule, exceptions, [], ref, t, [], [], changes, setChanges, insertData, setInsertData, id = 'schedUI');
    };

    const handleRemovePress = () => {
        handleCancelChanges(setSchedule, originalData, setDeletedItems, setChanges, setDuplicates);
    };

    const handleDelete = (item, index, attribute, modal) => {
        rowDelete(item, index, attribute, changes, setChanges, schedule, setSchedule, setDeletedItems, ref);
        unregister(`items.${item.schedUI}`);
    }
    //#endregion

    //#region Modal
    const closeModal = () => {
        setModalVisible(!modalVisible);
    }
    //#endregion

    //#region Render
    const renderItem = useCallback(({ item, index }) => {
        return (
            <Card
                style={[styles.cardStyleLocation]} >
                <Card.Content>
                    <FlatListView
                        styles={styles}
                        control={control}
                        item={item}
                        index={index}
                        handleDelete={handleDelete}
                        handleEditPress={flatlistEditPress}
                        modal={modal}
                        setValue={setValue}
                        options={options}
                        t={t}
                    />
                </Card.Content>
            </Card>
        )
    }, [schedule]);
    //#endregion

    return (
        <>
            <View style={styles.iconRow}>
                <View style={styles.leftIcons}>
                    <Ionicons
                        name={"add-circle-outline"}
                        style={styles.icon}
                        onPress={handleAddPress}
                    />
                    <Ionicons
                        name={"remove-circle-outline"}
                        style={styles.icon}
                        onPress={handleRemovePress}
                    />
                </View>
                <View style={[styles.rightIcon, { flexDirection: 'row' }]}>
                    {state && showState && <CustomLabel
                        value={`${t('common:state')}: ${t(`common:${state}`)}`}
                        type='EDIT_EMPLOYEE_STATE'
                    />}
                    <Ionicons
                        name={"close-circle-outline"}
                        style={styles.icon}
                        onPress={closeModal}
                    />
                </View>
            </View>
            <FlatList
                style={{ height: height / 3, flexGrow: 0 }}
                data={schedule}
                keyExtractor={(item, index) => `${item?.schedUI}`}
                renderItem={renderItem}
                scrollEnabled={true}
                refreshing={isLoading}
                ref={ref}
                initialNumToRender={10}
                ListHeaderComponent={
                    <CustomLabel
                        value={`${selectedEmployee?.name}'s ${t(`common:${modal?.title}`)}`}
                        type='SUBTITLE'
                    />
                }
                ListEmptyComponent={
                    isLoading ? (
                        <ActivityIndicator animating={true} color={colors.blue} />
                    ) : (
                        <CustomLabel
                            value={t("common:scheduleLoadingPreview")}
                            type="NO_BRANCHES"
                        />
                    )
                }
            />
            <View style={[styles.functionalityButtons]}>
                <CustomButton
                    text={t('common:saveChanges')}
                    onPress={handleSubmit(onSubmit)}
                    type='BUTTON_SAVE'
                    textTop='0'
                    sz={15}
                />
            </View>
        </>
    );
};

export default HRAdminSchedule;